// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-main-js": () => import("../src/templates/main.js" /* webpackChunkName: "component---src-templates-main-js" */)
}

